import React from 'react';
import type { UserCompaniesResponseDto } from '@relay-towing/api';

interface CompanySelectProps {
  companies: UserCompaniesResponseDto['companies'];
  value: string | null;
  onChange: (companyId: string) => Promise<void>;
}

const CompanySelect: React.FC<CompanySelectProps> = ({
  companies,
  value,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    void onChange(e.target.value);
  };

  if (companies.length === 0) {
    return (
      <div className="px-4 py-3 text-center text-sm text-gray-500">
        No companies available
      </div>
    );
  }

  return (
    <div className="mx-4">
      <select
        value={value || ''}
        onChange={handleChange}
        className="w-full px-4 py-2 rounded-[10px] text-white text-[17px] bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent cursor-pointer"
        style={{ background: '#1C1C1E' }}
      >
        {companies.map(({ company }) => (
          <option key={company.id} value={company.id}>
            {company.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CompanySelect;
